import { Injectable } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ManagerGuard {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const isAuthenticated = await this.authService.isAuthenticated();
    const isManager = await this.authService.isManager();
    const isAdmin = await this.authService.isAdmin();

    if (isAuthenticated && isManager || isAdmin) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }

  async canActivateChild(): Promise<boolean> {
    return this.canActivate();
  }
}

/**
 * Management area entry: managers, coordinators (read-only subset: deals and
 * valuation reports of their agencies) and admins. Manager-only pages add
 * managerGuard on their own route.
 */
@Injectable({
  providedIn: 'root'
})
export class ManagerOrCoordinatorGuard {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const [isAuthenticated, isManager, isCoordinator, isAdmin] = await Promise.all([
      this.authService.isAuthenticated(),
      this.authService.isManager(),
      this.authService.isCoordinator(),
      this.authService.isAdmin(),
    ]);

    if (isAuthenticated && (isManager || isCoordinator || isAdmin)) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}

export const managerGuard: CanActivateFn = () => inject(ManagerGuard).canActivate();
export const managerOrCoordinatorGuard: CanActivateFn = () => inject(ManagerOrCoordinatorGuard).canActivate();
export const managerChildGuard: CanActivateChildFn = () => inject(ManagerGuard).canActivateChild();